import styled, { css } from 'styled-components'

import { BadgeWrapper } from '../badge'

export const SelectWrapper = styled.div`
  margin: 0;

  position: relative;

  & + ${BadgeWrapper} {
    margin-top: 12px;
  }
`

export const SelectBlock = styled.div`
  box-sizing: border-box;

  margin: 0;
  padding: 0;

  width: 100%;

  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: 'tnum';

  position: relative;

  display: inline-block;

  cursor: pointer;
`

export const SelectSelector = styled.div<{ open: boolean }>`
  display: flex;

  position: relative;

  background-color: #ffffff;

  border: 1px solid #e1e1e1;
  border-radius: 7px;

  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

  width: 100%;
  min-width: 120px;
  height: 56px;

  padding: 0 18px;

  ${({ open = false }) =>
    open &&
    css`
      border-radius: 7px 7px 0 0;
    `}
`

export const SelectArrow = styled.span`
  display: inline-block;

  font-style: normal;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  line-height: 1;
  text-align: center;

  position: absolute;

  top: 57%;
  right: 23px;
  width: 12px;
  height: 6px;

  margin-top: -6px;

  pointer-events: none;
  user-select: none;
`

export const SelectIcon = styled.span<{ arrowDown: boolean }>`
  display: inline-block;

  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  text-rendering: optimizeLegibility;

  transition: transform 0.3s, -webkit-transform 0.3s;
  vertical-align: top;

  transform: rotate(${({ arrowDown }) => (arrowDown ? 0 : '180deg')});
`

export const SelectText = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  align-items: center;
  align-self: center;

  white-space: nowrap;
  text-overflow: ellipsis;

  padding: 0 18px 0 0;
  line-height: 30px;
  transition: all 0.3s;

  font-size: 16px;
`

export const SelectOptionsWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`

export const SelectDropdown = styled.div<{ open: boolean }>`
  background-color: #ffffff;
  border-color: #e1e1e1;
  border-style: solid;
  border-width: 0 1px 1px 1px;
  border-radius: 0 0 7px 7px;
  box-shadow: 0 12px 6px -4px rgb(0 0 0 / 12%), 0 12px 10px 0 rgb(0 0 0 / 8%),
    0 12px 8px 8px rgb(0 0 0 / 5%);

  margin: 0;
  padding: 0;
  min-width: 120px;
  width: 100%;

  color: rgba(0, 0, 0, 0.85);
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: 'tnum';
  font-size: 14px;
  font-variant: normal;

  position: absolute;
  left: -6000px;
  top: -742px;

  box-sizing: border-box;

  overflow: hidden;

  z-index: 1050;
  outline: none;

  ${({ open }) =>
    open &&
    css`
      top: 56px;
      left: 0;
    `}
`

export const SelectOption = styled.div<{ active: boolean }>`
  background-color: ${({ active }) => (active ? '#e0e0e0' : 'transparent')};
  border-bottom: 1px solid #dddfe5;

  display: flex;
  align-items: center;
  flex: auto;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  position: relative;

  min-height: 32px;

  padding: 7px 23px;

  font-weight: 400;
  font-size: 16px;
  line-height: 32px;

  transition: background-color 0.3s;

  &:hover {
    background-color: #e0e0e0;
  }

  &:last-child {
    border-bottom-width: 0;
  }
`

export const SelectContentIconWrapper = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;

  width: 32px;

  margin-right: 10px;
`
export const SelectContentIcon = styled.img`
  max-height: 32px;
`

export const SelectPrice = styled.span`
  font-size: 13px;
`
